import React from 'react';
import { Route } from 'react-router-dom';
import OrgStructureAssignments from '../pages/orgStructureAssignments/OrgStructureAssignments';
import CreateOrgStructureAssignment from '../pages/orgStructureAssignments/CreateOrgStructureAssignment';
import BulkOrgStructureAssignment from '../pages/orgStructureAssignments/BulkOrgStructureAssignment';
import EditOrgStructureAssignment from '../pages/orgStructureAssignments/EditOrgStructureAssignment';
import PermissionGuard from '../components/global/PermissionGuard';

const orgStructureAssignmentsRoutes = (
    <>
        <Route path="/org-structure-assignments" element={<PermissionGuard permission="org_structure_assignments_list"><OrgStructureAssignments /></PermissionGuard>} />
        <Route path="/org-structure-assignments/create" element={<PermissionGuard permission="org_structure_assignments_create"><CreateOrgStructureAssignment /></PermissionGuard>} />
        <Route path="/org-structure-assignments/bulk" element={<PermissionGuard permission="org_structure_assignments_create"><BulkOrgStructureAssignment /></PermissionGuard>} />
        <Route path="/org-structure-assignments/:id/edit" element={<PermissionGuard permission="org_structure_assignments_edit"><EditOrgStructureAssignment /></PermissionGuard>} />
    </>
);

export default orgStructureAssignmentsRoutes;
